var chunkMapping = {
	"418": [
		4418
	],
	"487": [
		3487
	],
	"497": [
		823,
		1246,
		1706,
		5162,
		5849,
		6028,
		6405,
		6745,
		8435,
		8829
	],
	"627": [
		4627
	],
	"637": [
		9637
	],
	"821": [
		8821
	],
	"848": [
		2848
	]
};
var idToExternalAndNameMapping = {
	"823": [
		"default",
		"./generalSettingsRoutes",
		5777
	],
	"1246": [
		"default",
		"./SchedulerRoutes",
		6832
	],
	"1706": [
		"default",
		"./loading-files-widget",
		2080
	],
	"2848": [
		"default",
		"./Scheduler",
		6832
	],
	"3487": [
		"default",
		"./UsersLayouts",
		8975
	],
	"4418": [
		"default",
		"./Wiki",
		2501
	],
	"4627": [
		"default",
		"./TestManager",
		2365
	],
	"5162": [
		"default",
		"./layouts",
		9304
	],
	"5849": [
		"default",
		"./projectsRoutes",
		8176
	],
	"6028": [
		"default",
		"./WikiRoutes",
		2501
	],
	"6405": [
		"default",
		"./notification-connection",
		2080
	],
	"6745": [
		"default",
		"./testManagerRoutes",
		2365
	],
	"8435": [
		"default",
		"./pages",
		9304
	],
	"8821": [
		"default",
		"./GeneralSettings",
		5777
	],
	"8829": [
		"default",
		"./statisticsRoutes",
		8975
	],
	"9637": [
		"default",
		"./ProjectLayouts",
		8176
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}